import axios from "axios";
import { danger, success, swal, useState, useUserPermissions } from "@";
import { useCharity } from "@/shared/hooks/useCharity";

// Permissions that grant access to the "revalidate cache" action.
export const REVALIDATE_PERMISSIONS = [
  "editProjects",
  "ourPartners",
  "viewSitePages",
  "editSitePages",
  "viewMainBanner",
  "editMainBanner",
  "generalSettings",
  "editGiftProject",
  "homepageSettings",
  "serviceLinkSettings",
  "editAssociationData",
  "arrangeHomepageItems",
];

export const useRevalidateAll = () => {
  const [isRevalidating, setIsRevalidating] = useState(false);
  const { charityStoreUrl } = useCharity();
  const { permissions } = useUserPermissions();

  // @ts-ignore
  const secret = import.meta.env.VITE_REVALIDATE_SECRET;
  const hasPermission = REVALIDATE_PERMISSIONS.some(
    (p) => permissions?.[p] || false,
  );
  // Whether the action should be offered at all (config + permission present).
  const canRevalidate = Boolean(charityStoreUrl && secret && hasPermission);

  const handleRevalidateAll = async () => {
    const storeUrl = charityStoreUrl?.replace(/\/$/, "");
    // @ts-ignore
    const secret = import.meta.env.VITE_REVALIDATE_SECRET;
    if (!storeUrl || storeUrl === "#" || !secret) {
      danger("لم يتم إضافة إعدادات تحديث الكاش");
      return;
    }
    setIsRevalidating(true);
    try {
      await axios.post(`${storeUrl}/api/revalidate/all`, null, {
        headers: { "x-revalidate-secret": secret },
      });
      await success(
        "تم تحديث الكاش بنجاح، قد يستغرق الأمر حوالى دقيقتين  لظهور التحديث في المتجر",
      );
    } catch (error) {
      danger("فشل تحديث الكاش");
    } finally {
      setIsRevalidating(false);
    }
  };

  // Ask for confirmation, then revalidate.
  const confirmAndRevalidate = async () => {
    const res = await swal(
      "تأكيد تحديث الكاش",
      "هل أنت متأكد أنك تريد تحديث كاش المنصة؟ قد يستغرق الأمر حوالى 1-3 دقائق لظهور التحديث في المتجر.",
      "نعم، تحديث ",
    );
    if (res.isConfirmed) handleRevalidateAll();
  };

  return {
    handleRevalidateAll,
    confirmAndRevalidate,
    canRevalidate,
    isRevalidating,
  };
};
